import React from "react";
import { Modal } from "react-bootstrap";
import { ShimmerTable } from "react-shimmer-effects";
import "./modal.css";

const OfferHistoryModal = ({
  showOfferHistory,
  historyModalState,
  resetOfferHistoryModalState,
  formatPrice,
}) => {
  return (
    <Modal
      centered
      className="cfd-disclaimer-modal"
      backdrop="static"
      show={showOfferHistory}
      onHide={resetOfferHistoryModalState}
      dialogClassName="cfd-right-modal-dialog"
      contentClassName="cfd-right-modal-content"
    >
      <Modal.Header closeButton>
        <Modal.Title className="cfd-table-title">CFD Offer History</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {historyModalState.isLoading ? (
          <div className="text-center">
            <ShimmerTable row={6} col={6} />
          </div>
        ) : historyModalState.error ? (
          <div className="text-center text-danger">
            <p>{historyModalState.error}</p>
          </div>
        ) : historyModalState.offerHistoryData &&
          historyModalState.offerHistoryData.length > 0 ? (
          <div className="table-responsive">
            <table className="table">
              <thead className="cfd-table-heading">
                <tr>
                  <th>Date</th>
                  <th>Time</th>
                  <th>List Price</th>
                  <th>Offer Price</th>
                  <th>Buyer’s Premium</th>
                  <th>Total Amount</th>
                </tr>
              </thead>
              <tbody className="cfd-table-body">
                {historyModalState.offerHistoryData.map((item, index) => (
                  <tr key={index}>
                    <td className={index % 2 !== 0 ? "cfd-row-striped" : ""}>
                      {item.date}
                    </td>
                    <td className={index % 2 !== 0 ? "cfd-row-striped" : ""}>
                      {item.time}
                    </td>
                    <td className={index % 2 !== 0 ? "cfd-row-striped" : ""}>
                      {formatPrice(item.listPrice)}
                    </td>
                    <td className={index % 2 !== 0 ? "cfd-row-striped" : ""}>
                      {formatPrice(item.offerAmount)}
                    </td>
                    <td className={index % 2 !== 0 ? "cfd-row-striped" : ""}>
                      {formatPrice(item.buyerPremium)}
                    </td>
                    <td className={index % 2 !== 0 ? "cfd-row-striped" : ""}>
                      {formatPrice(item.totalAmount)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="text-center">
            <p>No offer history available.</p>
          </div>
        )}
      </Modal.Body>
      {/* <Modal.Footer>
        <button
          className="btn btn-sm btn-thm cfd-btn-thm"
          onClick={resetOfferHistoryModalState}
        >
          Close
        </button>
      </Modal.Footer> */}
    </Modal>
  );
};

export default OfferHistoryModal;
